/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop at first stop codon`)
};

const es_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detener en el primer codón de parada`)
};

const de_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am ersten Stoppcodon anhalten`)
};

const nl_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop bij eerste stopcodon`)
};

const fr_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter au premier codon stop`)
};

const it_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermati al primo codone di stop`)
};

const pt_br2_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar no primeiro códon de parada`)
};

const pt_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar no primeiro codão de paragem`)
};

const ja_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の終止コドンで停止`)
};

const zh_translate_stop_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在第一个终止密码子处停止`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_stop_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_stop_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_stop_label", locale)
	if (locale === "en") return en_translate_stop_label(inputs)
	if (locale === "es") return es_translate_stop_label(inputs)
	if (locale === "de") return de_translate_stop_label(inputs)
	if (locale === "nl") return nl_translate_stop_label(inputs)
	if (locale === "fr") return fr_translate_stop_label(inputs)
	if (locale === "it") return it_translate_stop_label(inputs)
	if (locale === "pt-BR") return pt_br2_translate_stop_label(inputs)
	if (locale === "pt") return pt_translate_stop_label(inputs)
	if (locale === "ja") return ja_translate_stop_label(inputs)
	return zh_translate_stop_label(inputs)
};